import { httpClient } from '@texas/api/httpClient/httpClient';
import { ChatItems } from './aiMessageTypes';

export enum ThreadCategory {
  Agent = 1,
  Report = 2,
}

export enum ChatMessageEntityLinkType {
  Customer = 1,
  Concept = 2,
  ProductGroup = 3,
  Material = 4,
  Quality = 5,
  DimensionGroup = 6,
  Branch = 7,
}

export interface ChatThread {
  title: string;
  threadId: number;
  category: ThreadCategory;
}

export interface AiThreadSession {
  chatItems: ChatItems;
  threadId: number;
  title: string;
  category: ThreadCategory;
}

export const chatApi = {
  getSessions: () => httpClient.get<ChatThread[]>(`chat/sessions`),
  getSession: (threadId: number) =>
    httpClient.get<AiThreadSession>(`chat/session/${threadId}`),
  pollSession: (threadId: number) =>
    httpClient.get<ChatItems>(`chat/session/${threadId}/poll`, {
      timeout: 5000,
    }),
};
